import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var calc = {
    selectors: {
		calcRangeSlider: '[calc-range-slider]',
	},
	init: function () {
        var self = this;
        
        self.priceRange();
    },
    priceRange: function () {
        var self = this;

        var Volumephvodyobjem, Volumephvodyphnyni, Volumephvodyphmabyt = 0;

        jQuery(self.selectors.calcRangeSlider).each(function () {
            var start = [ parseFloat( jQuery(this).attr('data-start') ) ];
            var min = parseFloat( jQuery(this).attr('data-min') );
            var max = parseFloat( jQuery(this).attr('data-max') );
            var step = parseFloat( jQuery(this).attr('data-step'));
            var step = parseFloat( jQuery(this).attr('data-step'));

            var CalcSliderElement = this;
            noUiSlider.create( CalcSliderElement, {
                start: start,
                step: step,
                decimals: 1,
                tooltips: [ true ],
                connect: [true, false],
                format: {
                    to: (v) => parseFloat(v).toFixed(1),
                    from: (v) => parseFloat(v).toFixed(1)
                },
                range: {
                    'min': [min],
                    'max': [max]
                }
            });

            var prefix = jQuery(this).attr('data-prefix');
            var suffix = jQuery(this).attr('data-suffix');
            var output = jQuery(this).attr('data-output');
    
            CalcSliderElement.noUiSlider.on('update', function (values) {
                var data = self.formatNumber( ",", values[0] );
                var fieldInput = document.querySelector('input[name="' + output + '"]');

                fieldInput.value = parseFloat( values[0] );
                fieldInput.setAttribute('value', values[0]);

                if (output == 'Volumechlormaxi' || output == 'Volumekombimaxi' || output == 'Volumemultimaxi') {
                    self.Volumechlormaxi( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumeduomaxi') {
                    self.Volumeduomaxi( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumechlorsok') {
                    self.Volumechlorsok( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumevlockovac') {
                    self.Volumevlockovac( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumestabilizator') {
                    self.Volumestabilizator( values, prefix, suffix, output, data );
                }

                if (output == 'Volumezazimovac') {
                    self.Volumezazimovac( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumeodstranovaras') {
                    self.Volumeodstranovaras( values, prefix, suffix, output, data );
                }
                
                if (output == 'Volumechlorstart' || output == 'Volumeoxisok') {
                    self.Volumechlorstart( values, prefix, suffix, output, data );
                }

                if (output == 'Volumephvodyobjem' || output == 'Volumephvodyphnyni' || output == 'Volumephvodyphmabyt' ) {
                    // self.Volumechlorstart( values, prefix, suffix, output, data );
                    
                    switch ( output ) {
                        case 'Volumephvodyobjem':
                            Volumephvodyobjem = parseFloat( data ); 
                        break;
                        case 'Volumephvodyphnyni':
                            Volumephvodyphnyni = parseFloat( data ); 
                        break;
                        case 'Volumephvodyphmabyt':
                            Volumephvodyphmabyt = parseFloat( data ); 
                        break;
                    }

                    if( Volumephvodyobjem > 0 && Volumephvodyphnyni > 0 && Volumephvodyphmabyt > 0 ) {
                        // console.log( Volumephvodyobjem );
                        // console.log( Volumephvodyphnyni );
                        // console.log( Volumephvodyphmabyt );

                        var CalcSliderElementValue = jQuery('.' + output );
                        CalcSliderElementValue.html( parseFloat( data ) + suffix );

                        var value = self.returnDosing( Volumephvodyobjem, Volumephvodyphnyni, Volumephvodyphmabyt );
                        var bigger = Volumephvodyphnyni > Volumephvodyphmabyt ? '.phvody-result__bigger' : '.phvody-result__smaller';

                        // console.log( Volumephvodyphmabyt, bigger, value );

                        jQuery( '.phvody-result .phvody__grams' ).text( value );
                        jQuery( '.phvody-result .phvody__needed' ).text( Volumephvodyphmabyt );
                        jQuery( '.phvody-result p.active' ).removeClass( 'active' );
                        jQuery( '.phvody-result p' +  bigger ).addClass( 'active' );
                    }
                }
            });
        });        
    },
    Volumechlormaxi: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var resultData = '';

        var doporTabletaMin = Math.ceil( 1 / 30 * data ); // zaokouhlení nahoru
        var doporTabletaMax = Math.ceil( 1 / 20 * data );
        
        resultData = doporTabletaMin != doporTabletaMax ? doporTabletaMin + '-' +  doporTabletaMax : doporTabletaMin;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( resultData + suffix );
    },
    Volumeduomaxi: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var resultData = '';

        var doporTabletaMin = Math.ceil( 1 / 20 * data ); // zaokouhlení nahoru
        var doporTabletaMax = Math.ceil( 1 / 15 * data );
        
        resultData = doporTabletaMin != doporTabletaMax ? doporTabletaMin + '-' +  doporTabletaMax : doporTabletaMin;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( resultData + suffix );
    },
    Volumevlockovac: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var resultData = '';

        var doporPocetMin = 10 / 10 * data;
        var doporPocetMax = 50 / 10 * data;
        
        resultData = doporPocetMin + '-' +  doporPocetMax;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( resultData + suffix );
    },
    Volumechlorsok: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var resultData = 90 / 10 * data;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( resultData + suffix );
    },
    Volumechlorstart: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var resultData = '';

        var doporPocetMin = 40 / 10 * data;
        var doporPocetMax = 80 / 10 * data;
        
        resultData = doporPocetMin + ' - ' +  doporPocetMax;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( resultData + suffix );
    },
    Volumestabilizator: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);

        var doporPocetMin = 250 / 10 * data;
        var doporPocetMax = 500 / 10 * data;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( prefix + doporPocetMin + suffix + doporPocetMax );
    },
    Volumezazimovac: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);
        var CalcSliderElementResult2 = jQuery('.Result2' + output);

        var doporPocetMin = 1000 / 20 * data;
        var voda =  Math.round( doporPocetMin / 1000 * 9 * 100) / 100;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( doporPocetMin + suffix );
        CalcSliderElementResult2.html( voda );
    },
    Volumeodstranovaras: function ( values, prefix, suffix, output, data ) {   
        var self = this;
        
        var CalcSliderElementValue = jQuery('.' + output);
        var CalcSliderElementResult = jQuery('.Result' + output);
        var CalcSliderElementResult2 = jQuery('.Result2' + output);
        var CalcSliderElementResult3 = jQuery('.Result3' + output);

        var doporPocetMin1 = 100 / 10 * data;
        var doporPocetMax1 = 150 / 10 * data;
        
        var doporPocetMin2 = 150 / 10 * data;
        var doporPocetMax2 = 200 / 10 * data;
        
        var doporPocetMin3 = 300 / 10 * data;
        var doporPocetMax3 = 400 / 10 * data;

        CalcSliderElementValue.html( data );
        CalcSliderElementResult.html( doporPocetMin1 + suffix +'  '+ doporPocetMax1 + suffix );
        CalcSliderElementResult2.html( doporPocetMin2 + suffix +'  '+ doporPocetMax2 + suffix );
        CalcSliderElementResult3.html( doporPocetMin3 + suffix +'  '+ doporPocetMax3 + suffix );
    },
    /*priceRangeReset: function ( filterContainer ) {
        var self = this;

        jQuery(filterContainer).find(self.selectors.price).each(function () {
            var start = [ parseInt( jQuery(this).attr('data-start') ), parseInt( jQuery(this).attr('data-end') ) ];
            
            var CalcSliderElement = this;
            CalcSliderElement.noUiSlider.set([ start[0] , start[1]]);
        });
    },
    formatString: function (prefix, suffix, field) {
        return prefix + field + suffix;
    }, */
    formatNumber: function (separator, x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    },
    objectSize: function(obj) {
        var size = 0,
          key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    },
    /**
     * Calculate dosing based on data
     *
     * @param  array  $poolSizeData
     * @param  float  $phHave
     * @param  float  $phWant
     * @return int
     */
    returnDosing: function( poolSize, phHave, phWant ) {
        var self = this;

        // console.log( 'yeah' );
        // console.log( poolSize, phHave, phWant );

        if( phHave == phWant ) return 0; // if pH is the same, everyhing is ok, no need to calculate

        var returnValue = 0;

        // array data ( poolSize in m3 => steppter in size )
        var pHplusPoolSize  = { 5 : 50, 10 : 100, 15 : 150, 20 : 200, 25 : 250, 30 : 300, 35 : 350, 40 : 400, 45 : 450, 50 : 500 };
        var pHminusPoolSize = { 5 : 40, 10 : 80,  15 : 120, 20 : 160, 25 : 200, 30 : 240, 35 : 280, 40 : 320, 45 : 360, 50 : 400 };

        // device which calculation and array we will be using
        if( phHave > phWant ) {
            var calculation = phHave - phWant; // calculation to be positive
            var array_type  = self.calculate( pHminusPoolSize ); // return full array of data
        } else {
            var calculation = phWant - phHave; // calculation to be positive
            var array_type  = self.calculate( pHplusPoolSize );  // return full array of data
        }

        var value = calculation.toFixed( 1 ); // calculate difference, get float, transform to string for index
        
        // console.log( array_type );
        // console.log( value );

        // if difference is in array, return data OR return the largest one (diff is too big)
        if( array_type[ value ] != undefined ) {
            returnValue = array_type[ value ][ poolSize ]['size'];
        } else {
            var lastKey = Object.keys( array_type )[Object.keys( array_type ).length-1];
            returnValue = array_type[ lastKey ][ poolSize ][ 'size' ];
        }

        return returnValue;
    },

    /**
     * Calculate dosing based on data
     *
     * @param  array  $poolSizeData
     * @param  int    $min
     * @param  int    $max
     * @param  int    $divider
     * @param  int    $decimal
     * @return int
     */
    calculate: function( poolSizeData ) {
        var min = 1;
        var max = 20;
        var divider = 10;

        if( poolSizeData == undefined ) return false; // no array sizes, no data
        // console.log( poolSizeData );

        var pH = {}; // final list
        for( var index = min; index <= max; index++ ) {
            var calculation = index / divider;
            // console.log( calculation );

            var arrayindex = calculation.toFixed( 1 );
            pH[ arrayindex ] = {};

            jQuery.each( poolSizeData, function( size, multiplier ) {
                pH[ arrayindex ][ size ] = { size : ( index * multiplier ) };
            });
        }

        return pH;
    }
};

export { calc };
